const metadata = {
  //classic
  "CP-TRIP-CLAS-0000-001": {
    Center: "3072_1536_32_16",
    Sides: "3072_1536_32_16",
    _size: "3072_4608"
  },
  // classic flow
  "CP-TRIP-CLFL-0000-001": {
    Center: "3072_1536_32_16",
    Sides: "2688_1536_28_16",
    _size: "3072_4608"
  },
  // cozy
  "CP-TRIP-COZ-0000-001": {
    Center: "1920_960_20_10",
    Sides: "1920_960_20_10",
    _size: "1920_2880"
  },
  // cozy flow
  "CP-TRIP-CZFL-0000-001": {
    Center: "1920_960_20_10",
    Sides: "1728_960_18_10",
    _size: "1920_2880",
  }
};

export default metadata;
